import { useMutation, useQueryClient } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const deleteErrorNotif =
  ({
    partnerId,
    makeRequest,
  }: {
    partnerId: string;
    makeRequest: ImperativeRequestFn;
  }) =>
  async (errNotifId: string): Promise<void> => {
    const { error } = await makeRequest({
      path: `/partners/${partnerId}/webhooks/error-notifs/${errNotifId}`,
      method: 'delete',
    });
    if (error) throw new Error(error?.message ?? 'Delete failed');
  };

type UseDeleteErrorNotifOptions = {
  partnerId: string;
  config?: MutationConfig<ReturnType<typeof deleteErrorNotif>>;
};

export const useDeleteErrorNotif = ({
  partnerId,
  config,
}: UseDeleteErrorNotifOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: deleteErrorNotif({ partnerId, makeRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['webhook-error-notifs', partnerId],
      });
    },
  });
};
